export default "/images/vendor/flag-icon-css/flags/1x1/sm.svg?b57f66050d777f87e0a5ca189c484b15";